import API from "@/api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async getCycle({ state }, id) {
      try {
        return await API.Cycles.show(id);
      } catch (e) {
        throw e;
      }
    },

    async searchWithPendingPayment({ state }) {
      try {
        return await API.Cycles.searchWithPendingPayment();
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/cycles.js